import {
  Badge,
  DigitalSignatureLogo,
  Icon,
  Tooltip,
} from "@smart/itops-sb-design-system-dom";
import { useProviderInfo } from "@smart/itops-smokeball-components-dom";

export const ChargeableBadge = ({
  withLogo = true,
}: {
  withLogo?: boolean;
}) => {
  const providerInfo = useProviderInfo();
  const isTriConvey = providerInfo?.label === "triConvey";
  const providerLabel = isTriConvey ? "triSearch" : "InfoTrack";

  return (
    <>
      {withLogo && (
        <DigitalSignatureLogo
          variant={isTriConvey ? "trisign" : "signit"}
          className="w-24"
        />
      )}
      <Tooltip
        text={
          <>
            <strong className="text-ui">Pricing varies</strong>
            <br />
            Per-signature pricing depends on your region and your firm&apos;s
            {` ${providerLabel}`} agreement. See your exact rate in your{" "}
            <strong>{providerLabel} account.</strong>
          </>
        }
        placement="top-start"
        offsetBy={10}
      >
        <div className="flex items-center gap-xSmall">
          <Badge label="Chargeable" theme="success" />
          <Icon name="regularCircleInfo" />
        </div>
      </Tooltip>
    </>
  );
};
